app.service("ProductDoorService", ['$rootScope', 'ProductService',
    function ($rootScope, ProductService) {

        const siteHelper = $rootScope.site_helper;
        const modelConstructor = $rootScope.model_constructor;

        const defaultMidrailHeight = 655;

        const standardDoorOption = {
            id: 'door',
            name: 'Door'
        }

        const ProductDoorModel = modelConstructor.extend(ProductService.BasicProductModel, {
            id: "product_door",
            applyItemHandler: applyItemHandler,
            is_single_item_model: true
        });

        this.factory = new ProductService.BasicProductModelFactory({
            birth: function (values) {
                return new ProductDoorModel(values);
            },

            validVariationPointers: function (variationIDs) {
                return ['browse_id', 'base_component_id', 'parent_category_id', 'request_range_id', 'site_range_id', 'style_id'];
            },

            applyModelVariation: applyModelVariation
        });


        function applyModelVariation(model) {

            this.super(model);

            const baseComponentID = model.base_component_id;
            const parentCategoryID = model.parent_category_id;

            const siteRangeID = model.site_range_id;

            const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);

            const isFrame = baseComponentID === "frame";
            let isSingleItemModel = true;
            let doorOptions = [standardDoorOption];
            let hingeHoleAvailable = true;
            if (!isFrame) {
                if (parentCategoryID === "door") {

                    if (requestRangeID === "pronto") {
                        isSingleItemModel = false;
                        doorOptions = [
                            standardDoorOption,
                            {
                                id: 'unglazed_frame',
                                name: 'Unglazed'
                            },
                            {
                                id: 'glazed_door',
                                name: 'Glazed'
                            },
                            {
                                id: 'square_door',
                                name: 'Square'
                            }
                        ];
                    }
                }
            } else {
                if (
                    parentCategoryID === "frame_drawer" ||
                    parentCategoryID === "frame_face"
                ) {
                    hingeHoleAvailable = false;
                }
            }

            model.request_range_id = requestRangeID;
            model.is_frame = isFrame;
            model.is_single_item_model = isSingleItemModel;
            model.door_options = doorOptions;
            model.hinge_hole_available = hingeHoleAvailable;

        }

        function applyItemHandler(product) {
            this.super(product);

            const model = this.root;

            const isFrame = model.is_frame;

            applySmallLargeProduct(product);

            product.is_frame = isFrame;
            product.standard_sizes = product.standard_sizes ? product.standard_sizes : [];

            const priceMatrix = createPriceMatrix(product, model.door_options);
            const validProductData = createValidProductData(priceMatrix);
            const standardMinMax = getStandardMinMax(validProductData)

            product.local_option_term_config = getLocalOptionTermConfig(model.request_range_id, model.base_component_id, model.parent_category_id, model.style_id);

            if (!isFrame) {
                product.group_name = "Door";
            } else {
                product.group_name = "Frame"
                product.selection_inputs.midrail = {
                    default_value: defaultMidrailHeight,
                    defaultDisabled: true
                }
                $rootScope.service.product.resetSelection(product);
            }


            siteHelper.applyValues(product, {

                option_layout: "list",

                quantity: 1,
                height: '',
                width: '',
                applynonstdsurcharge: false,
                price: 0,
                rotate_grain: false,
                drillside: '',
                drill_0: '',
                drill_1: '',
                drill_2: '',
                drill_3: '',
                drill_4: false,
                drill_5: false,
                jpull_position: "top",
                hinge_hole_available: model.hinge_hole_available,
                door_options: model.door_options,
                price_matrix: priceMatrix,
                valid_product_data: validProductData,
                minimum_standard_price: standardMinMax.min,
                maximum_standard_price: standardMinMax.max,

                left_side_square: false,
                right_side_square: false,
                types: ['door'],
                expected_door_option_id: "door",

            }, product);

            siteHelper.applyValues(product, {
                getCurrentDoorOptionID: function () {
                    return product.expected_door_option_id;
                },
                collectImageParams: function () {
                    const params = this.super();

                    const complexOption = $rootScope.service.option_product.currentComplexOption(product);

                    params.image_type_id = "product";
                    params.site_range_id = $rootScope.navigation_model.state_ids.site_range_id;
                    params.colour_id = $rootScope.navigation_model.state_ids.colour_id;
                    params.style_id = $rootScope.navigation_model.state_ids.style_id;
                    params.api_code = product.api_code;
                    params.product_width = product.width;
                    params.product_height = product.height;
                    params.drillside = product.drillside;
                    params.drill_0 = product.drill_0;
                    params.drill_1 = product.drill_1;
                    params.drill_2 = product.drill_2;
                    params.drill_3 = product.drill_3;
                    params.drill_3 = product.drill_3;
                    params.drill_4 = product.drill_4;
                    params.drill_5 = product.drill_5;
                    params.option_id = complexOption.id;
                    params.rotate_grain = product.rotate_grain;

                    params.panels = product.panels;
                    params.top_panel_height = product.top_panel_height;
                    params.bottom_panel_height = product.bottom_panel_height;

                    params.midrail = product.option_term_values.midrail ? product.option_term_values.midrail.midrail_height : null;
                    params.knebworth_position = product.option_term_ids.handle_position_knebworth;
                    params.handle_position = product.option_term_ids.handle_position_knebworth;
                    params.integra_position = product.option_term_ids.handle_position_integra;

                    params.left_angle_height = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_height : null;
                    params.left_angle_width = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_width : null;
                    params.right_angle_height = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_height : null;
                    params.right_angle_width = product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_width : null;

                    return params;
                },
                finalPrice: function () {
                    return finalPrice(product);
                }
            });

            if (model.request_range_id === "pronto") {
                siteHelper.applyValues(product, {
                    getCurrentDoorOptionID: function () {
                        const optionTermValue = this.root.option_term_ids.selected_door_option;
                        if (optionTermValue) {
                            return optionTermValue;
                        }
                        return this.super();
                    },
                });
            }
        }

        function applySmallLargeProduct(product) {
            let i;

            let heightBreakPoint = 0;
            let haveSmallLargeProducts = false;
            if (["frame_wave", "frame_porthole", "frame_square_hole", "frame_open"].includes(product.parent_category_id)) {//open_frame_inset ??
                heightBreakPoint = 1700;
            }
            const smallProduct = heightBreakPoint ? product['small_' + product.api_code] : null;
            const largeProduct = smallProduct ? product['large_' + product.api_code] : null;
            if (heightBreakPoint && largeProduct) {
                haveSmallLargeProducts = true;
                if (smallProduct && smallProduct.style_exceptions) {
                    for (i = 0; i < smallProduct.style_exceptions.length; i++) {
                        product.style_exceptions[smallProduct.style_exceptions[i]] = true;
                    }
                }
            }
            product.have_small_large_products = haveSmallLargeProducts;
            product.height_break_point = heightBreakPoint;
            product.small_product = smallProduct;
            product.large_product = largeProduct
        }

        function getLocalOptionTermConfig(requestRangeID, baseComponentID, parentCategoryID, styleID) {

            if (baseComponentID === "door") {

                if (parentCategoryID === "door") {
                    if (requestRangeID === "pronto") {
                        return [
                            {
                                option_id: "selected_door_option",
                                value: "door",
                            }
                        ];
                    }
                    if (requestRangeID === "bella") {
                        if (styleID === "lazio" || styleID === "segreto") {
                            return [
                                {
                                    option_id: "handle_colour",
                                    required: true
                                }
                            ]
                        }
                        return [
                            {
                                option_id: "handle_position_integra",
                                required: true
                            },
                            {
                                option_id: "handle_position_knebworth",
                                required: true
                            },
                            {
                                option_id: "midrail",
                                required: true
                            }
                        ]
                    }
                }
                if (parentCategoryID === "door_sloping") {
                    if (styleID === "segreto") {

                        return [
                            {
                                option_id: "handle_colour",
                                required: true
                            },
                            {
                                option_id: "door_sloping_angle",
                                required: true
                            }
                        ]
                    }
                    return [
                        {
                            option_id: "handle_position_knebworth",
                            required: true
                        },
                        {
                            option_id: "door_sloping_angle",
                            required: true
                        }
                    ]
                }
                if (parentCategoryID === "door_multi_panel") {

                }
            }

            if (baseComponentID === "frame") {
                if (["frame_open", "frame_wave", "frame_porthole", "frame_square_hole", "frame_five_hole", "frame_letter_box"].includes(parentCategoryID)) {

                    return [
                        {
                            option_id: "handle_position_integra",
                            required: true
                        },
                        {
                            option_id: "handle_position_knebworth",
                            required: true
                        }
                    ];
                }
            }
            return [];
        }

        function finalPrice(product) {
            if (applyStandardSize(product)) {
                return $rootScope.service.product.finalPrice(product, product.base_price);
            }
            return 0;
        }

        function applyStandardSize(product) {
            let i, j;
            const width = product.width;
            const height = product.height;

            if (!width || !height) {
                return false;
            }

            const doorOptionID = product.getCurrentDoorOptionID();

            let useStandardSize;
            let isStandardSize = false;
            for (i = 0; i < product.price_matrix.length; i++) {
                for (j = 0; j < product.price_matrix[i].length; j++) {
                    const matrixItem = product.price_matrix[i][j];
                    if (matrixItem.width > width) {
                        break;
                    }
                    if (matrixItem.width === width && matrixItem.height === height) {
                        const productData = matrixItem.product_data;
                        if (productData && productData[doorOptionID] && !productData[doorOptionID].hidden) {
                            useStandardSize = productData[doorOptionID];
                            isStandardSize = true;
                        }
                    }
                }
                if (product.price_matrix[0].height > height) {
                    break;
                }
            }

            let m2mProduct;
            if (product.m2m_drawer && height < product.m2m_door.minimum_height) {
                m2mProduct = product.m2m_drawer
            } else {
                m2mProduct = product.m2m_door
            }
            if (!isStandardSize) {
                const useM2mProduct = doorOptionID === "door" && m2mProduct && m2mProduct.standard_sizes && m2mProduct.standard_sizes.length;
                if (useM2mProduct) {
                    for (i = 0; i < m2mProduct.standard_sizes.length; i++) {
                        const checkStandardSize = m2mProduct.standard_sizes[i];
                        if (checkStandardSize.width >= width && checkStandardSize.height >= height) {
                            useStandardSize = checkStandardSize;
                            break;
                        }
                    }
                }
                if (!useStandardSize) {

                    let foundStandardSize = null;
                    for (i = 0; i < product.standard_sizes.length; i++) {
                        const checkStandardSize = product.standard_sizes[i];
                        if (checkStandardSize.width >= width && checkStandardSize.height >= height) {
                            foundStandardSize = checkStandardSize;
                            break;
                        }
                    }
                    if (!foundStandardSize && !useM2mProduct) {
                        foundStandardSize = product.standard_sizes.length ? product.standard_sizes[product.standard_sizes.length - 1] : null;
                    }
                    if (foundStandardSize) {
                        if (product.door_options.length === 1) {
                            useStandardSize = foundStandardSize;
                        } else if (foundStandardSize[doorOptionID]) {
                            useStandardSize = foundStandardSize[doorOptionID];
                        }
                    }
                    if (!useStandardSize && useM2mProduct) {
                        useStandardSize = m2mProduct.standard_sizes.length ? m2mProduct.standard_sizes[m2mProduct.standard_sizes.length - 1] : null;
                    }
                }
            }

            if (!useStandardSize || (!isStandardSize && (doorOptionID !== "door" || product.prevent_non_standard_size))) {
                return false;
            }
            product.applynonstdsurcharge = !isStandardSize;
            product.base_price = useStandardSize.base_price;
            product.discount_group = useStandardSize.discount_group;

            product.current_surcharge = product.surcharge;
            product.current_non_standard_surcharge = product.non_standard_surcharge;
            if (!product.prevent_non_standard_size) {
                if (product.have_small_large_products) {
                    if (product.height < product.height_break_point) {
                        product.current_surcharge = product.small_product.surcharge;
                        product.current_non_standard_surcharge = product.small_product.non_standard_surcharge;
                    } else {
                        product.current_surcharge = product.large_product.surcharge;
                        product.current_non_standard_surcharge = product.large_product.non_standard_surcharge;
                    }
                } else if (useStandardSize.rules) {
                    product.current_surcharge = product[useStandardSize.rules].surcharge;
                    product.current_non_standard_surcharge = product[useStandardSize.rules].non_standard_surcharge;
                } else if (product.request_range_id === "pronto") {

                    product.current_surcharge = m2mProduct.surcharge;
                    product.current_non_standard_surcharge = m2mProduct.non_standard_surcharge;

                }
            }
            return true;
        }


        function createPriceMatrix(product, modelDoorOptions) {

            const disabledDoors = {
                lacarre_gloss_light_grey: {
                    396: {
                        895: {door: true}
                    },
                    446: {
                        715: {door: true}
                    },
                    496: {
                        715: {door: true}
                    }
                },
                jayline_gloss_dust_grey: {
                    596: {
                        715: {door: true}
                    }
                },
                firbeck_supergloss_dust_grey: {
                    596: {
                        715: {door: true}
                    }
                }
            }


            function isProductHidden(product, width) {
                return false;
            }

            function getGroupDiscount(standardSize, surcharge) {

                const customerData = $rootScope.model.account.customer_data;
                if (standardSize.discount_group && customerData && typeof customerData.discounts !== 'undefined' && typeof customerData.discounts[standardSize.discount_group] !== 'undefined') {
                    return (customerData.discounts[standardSize.discount_group].discount / 100) * (standardSize.base_price + surcharge);
                }
                return 0;
            }

            function getProductSurcharge(product, standardSize) {


                let productSurcharge = 0;

                if (product.surcharge) {
                    productSurcharge += (product.surcharge / 100) * standardSize.base_price;
                }


                if (product.have_small_large_products) {
                    if (standardSize.height < product.height_break_point) {
                        productSurcharge += (product.small_product.surcharge / 100) * standardSize.base_price;
                    } else {
                        productSurcharge += (product.large_product.surcharge / 100) * standardSize.base_price;
                    }
                }

                if (product.range === "bella") {
                    if (product.apply_style_surcharge) {
                        if (!$rootScope.navigation_model.state_values.style_minimum_surcharge_height || standardSize.height >= $rootScope.navigation_model.state_values.style_minimum_surcharge_height) {
                            productSurcharge += ($rootScope.navigation_model.state_values.style_surcharge / 100) * standardSize.base_price;
                        }
                    }
                    if (product.apply_colour_surcharge) {
                        productSurcharge += ($rootScope.navigation_model.state_values.colour_surcharge / 100) * standardSize.base_price;
                    }
                }

                return productSurcharge;
            }

            function isDoorDisabled(product, width, height, doorOptionID) {

                const byDoor = disabledDoors[product.id];
                if (!byDoor) {
                    return false;
                }
                const byWidth = byDoor[width];
                if (!byWidth) {
                    return false;
                }
                const byHeight = byWidth[height];
                if (!byHeight) {
                    return false;
                }
                return byHeight === true || !doorOptionID || !!byHeight[doorOptionID];
            }

            function calculatePriceFunction(productData) {
                return function () {
                    const productSurcharge = getProductSurcharge(product, productData.standard_size);
                    let discountSurcharge = productSurcharge;
                    let fullSurcharge = productSurcharge;

                    if (['zurfiz', 'valore'].includes(product.range)) {
                        const colorSurcharge = ($rootScope.navigation_model.state_values.colour_surcharge / 100) * productData.standard_size.base_price;
                        discountSurcharge = colorSurcharge;
                        fullSurcharge = productSurcharge + colorSurcharge;
                    }

                    const groupDiscount = getGroupDiscount(productData.standard_size, discountSurcharge);


                    return productData.standard_size.base_price + fullSurcharge - groupDiscount;
                }
            }

            function calculateProntoPriceFunction(productData) {
                return function () {
                    return productData.base_price - (getGroupDiscount(productData.standard_size, 0));
                }
            }

            let i, j, productData, width, height, standardSize, doorOptionID, doorOption;


            const sortableSizes = [];

            const standardWidths = [];
            const standardHeights = [];
            for (i = 0; i < product.standard_sizes.length; i++) {
                standardSize = product.standard_sizes[i];
                sortableSizes.push(product.standard_sizes[i]);
            }

            sortableSizes.sort(function (a, b) {
                if (a.width < b.width) {
                    return -1;
                }
                if (a.width > b.width) {
                    return 1;
                }
                return 0;
            })

            for (i = 0; i < sortableSizes.length; i++) {
                standardSize = sortableSizes[i];
                if (i === 0 || standardSize.width !== sortableSizes[i - 1].width) {
                    standardWidths.push({width: standardSize.width});
                }
            }

            sortableSizes.sort(function (a, b) {
                if (a.height < b.height) {
                    return -1;
                }
                if (a.height > b.height) {
                    return 1;
                }
                return 0;
            })

            for (i = 0; i < sortableSizes.length; i++) {
                standardSize = sortableSizes[i];
                if (i === 0 || standardSize.height !== sortableSizes[i - 1].height) {
                    standardHeights.push({height: standardSize.height});
                }
            }

            const matrix = [];
            const widthIndexes = {};
            const heightIndexes = {};

            for (i = 0; i < standardHeights.length; i++) {
                matrix.push([]);
                heightIndexes[standardHeights[i].height] = i;
                for (j = 0; j < standardWidths.length; j++) {
                    matrix[i].push({
                        width: standardWidths[j].width,
                        height: standardHeights[i].height,
                        product_data: null
                    })
                    if (i === 0) {
                        widthIndexes[standardWidths[j].width] = j;
                    }
                }
            }

            for (i = 0; i < product.standard_sizes.length; i++) {
                standardSize = product.standard_sizes[i];
                width = standardSize.width
                height = standardSize.height;

                standardSize.hidden = standardSize.hidden || isProductHidden(product, width);
                const hidden = standardSize.hidden;

                productData = {};
                if (product.request_range_id === 'pronto') {

                    for (j = 0; j < modelDoorOptions.length; j++) {
                        productData[modelDoorOptions[j].id] = null;
                    }

                    for (doorOptionID in productData) {
                        if (standardSize[doorOptionID]) {

                            productData[doorOptionID] = {
                                standard_size: standardSize[doorOptionID],
                                rules: standardSize.rules,
                                hidden: hidden,
                                base_price: standardSize[doorOptionID].base_price,
                                getMatrixPrice: null,
                                formatted_price: null,
                                discount_group: standardSize[doorOptionID].discount_group,
                                notice: standardSize[doorOptionID].notice,
                                disabled: isDoorDisabled(product, width, height, doorOptionID)
                            }
                            productData[doorOptionID].getMatrixPrice = calculateProntoPriceFunction(productData[doorOptionID])
                        }
                    }
                } else {

                    doorOptionID = modelDoorOptions[0].id;
                    productData[doorOptionID] = {
                        standard_size: standardSize,
                        rules: standardSize.rules,
                        hidden: hidden,
                        base_price: standardSize.base_price,
                        getMatrixPrice: null,
                        formatted_price: null,
                        discount_group: standardSize.discount_group,
                        door_option_id: modelDoorOptions[0].id,
                        disabled: isDoorDisabled(product, width, height, doorOptionID)
                    }
                    productData[doorOptionID].getMatrixPrice = calculatePriceFunction(productData[doorOptionID])
                }

                const widthIndex = widthIndexes[width];
                const heightIndex = heightIndexes[height];
                matrix[heightIndex][widthIndex].product_data = productData;

            }

            if (matrix.length > 0) {
                for (i = 0; i < matrix.length; i++) {
                    let heightHidden = true;
                    for (j = 0; j < matrix[i].length; j++) {
                        productData = matrix[i][j].product_data;
                        if (productData) {
                            for (doorOptionID in productData) {
                                doorOption = productData[doorOptionID];
                                if (doorOption && !doorOption.hidden) {
                                    heightHidden = false;
                                    break;
                                }
                            }
                            if (!heightHidden) {
                                break;
                            }
                        }
                    }
                    if (heightHidden) {
                        for (j = 0; j < matrix[i].length; j++) {
                            matrix[i][j].heightHidden = true;
                        }
                    }
                }
                for (i = 0; i < matrix[0].length; i++) {
                    let widthHidden = true;
                    for (j = 0; j < matrix.length; j++) {
                        productData = matrix[j][i].product_data;
                        if (productData) {
                            for (doorOptionID in productData) {
                                doorOption = productData[doorOptionID];
                                if (doorOption && !doorOption.hidden) {
                                    widthHidden = false;
                                    break;
                                }
                            }
                            if (!widthHidden) {
                                break;
                            }
                        }
                    }
                    if (widthHidden) {
                        for (j = 0; j < matrix.length; j++) {
                            matrix[j][i].widthHidden = true;
                        }
                    }
                }
            }

            return matrix;
        }

        function createValidProductData(priceMatrix) {
            const object = {};
            for (let i = 0; i < priceMatrix.length; i++) {
                for (let j = 0; j < priceMatrix[i].length; j++) {
                    const square = priceMatrix[i][j];
                    if (!square.product_data) {
                        continue;
                    }
                    const productData = {};
                    let haveData = false;
                    for (let key in square.product_data) {
                        const doorOption = square.product_data[key];
                        if (!doorOption || doorOption.hidden) {
                            continue
                        }
                        haveData = true;
                        productData[key] = doorOption;
                    }
                    if (!haveData) {
                        continue;
                    }
                    if (!object[square.height]) {
                        object[square.height] = {};
                    }
                    object[square.height][square.width] = productData;
                }
            }

            return object;
        }

        function getStandardMinMax(productData) {
            let min = null;
            let max = null;
            for (let height in productData) {
                for (let width in productData[height]) {
                    const doorData = productData[height][width].door;
                    if (doorData && doorData.hasOwnProperty('base_price')) {
                        const basePrice = doorData.base_price;
                        if (min === null || basePrice < min) {
                            min = basePrice;
                        }
                        if (max === null || basePrice > max) {
                            max = basePrice;
                        }
                    }
                }
            }
            return {
                min: min,
                max: max
            }
        }

    }]);